<template>
    <div>
      <div class="calendar-grid">
        <div class="day-name" v-for="(d, i) in weekDays" :key="i">{{ d }}</div>  
        <div
          v-for="day in calendarDays"
          :key="day.format('YYYY-MM-DD')"
          class="day"
          :class="{
            selected: isSelected(day),
            otherMonth: !isCurrentMonth(day)
          }"
          @click="toggleDate(day)"
        >
          {{ day.date() }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import moment from 'moment'
  
  export default {
    props: {
      year: { type: Number, required: true },
      month: { type: Number, required: true }, // 0-indexed
      value: { type: Array, default: () => [] }
    },
    data() {
      return {
        selectedDates: [...this.value]
      }
    },
    computed: {
      weekDays() {
        return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      },
      calendarDays() {
        const firstDayOfMonth = moment({ year: this.year, month: this.month, day: 1 })
        const startOfCalendar = firstDayOfMonth.clone().startOf('week') // start on Sunday
  
        const days = []
        for (let i = 0; i < 42; i++) {
          days.push(startOfCalendar.clone().add(i, 'days'))
        }
        return days
      }
    },
    methods: {
      isSelected(day) {
        return this.selectedDates.some(d => moment(d).isSame(day, 'day'))
      },
      isCurrentMonth(day) {
        return day.month() === this.month
      },
      toggleDate(day) {
            // ✅ Solo permitir seleccionar días del mes actual
            if (!this.isCurrentMonth(day)) return;

            const dateStr = day.format('YYYY-MM-DD')
            const index = this.selectedDates.findIndex(d => d === dateStr)
            if (index === -1) {
                this.selectedDates.push(dateStr)
            } else {
                this.selectedDates.splice(index, 1)
            }
            this.$emit('input', this.selectedDates)
        }
   
    },
    watch: {
      value(newVal) {
        this.selectedDates = [...newVal]
      }
    }
  }
  </script>
  
  <style scoped>
  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
    margin-top: 10px;
  }
  .day-name {
    font-weight: bold;
    text-align: center;
    color: #444;
  }
  .day {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
  }
  .day.selected {
    background-color: #007bff;
    color: white;
    font-weight: bold;
  }
  .day.otherMonth {
    background-color: #f0f0f0;
    color: #aaa;
  }
  </style>
  